import apiClient from '@/utils/apiClient';

export default {
    getCities(searchInput) {
        return apiClient.get('/get_cities', { params: { search: searchInput || '' } });
    },
};
